/**
 * `result` shows action results and hides them after a while
 *
 *
 * ## usage
 * ```html
 * <result [status]='status' ></result>
 * ```
 */
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ResultComponentDef } from '@df/ui/api/result.component.def';

@Component({
    selector: 'result',
    templateUrl: './result.html',
    styleUrls: ['./result.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultComponent extends ResultComponentDef {
    @Input()
    holdPlace: boolean;
}
